import { useState } from "react";
import AddServiceIcon from "../../assets/svg/add (1) 1.svg";
import Logo from "../../assets/svg/chevrolet-10 1.svg";
import Editicon from "../../assets/svg/Editicon.svg";
import Van from "../../assets/svg/Van.svg";
import "../../pages/Vehicles/Vehicles.css";
import { VanModal } from "../Modals/VanModal";
export function InfoItem({ label, value }) {
  return (
    <h6
      className="d-flex justify-content-between align-items-center text-secondary"
      style={{ lineHeight: "26.24px" }}
    >
      {label}
      <span className="text-dark label-van">{value}</span>
    </h6>
  );
}

function VanProfileCard({
  StuffsVan,
  vehicleById,
  setActivePage,
  getVehicleById
}) {
  const [isEdit, setIsEdit] = useState(false)
  const[vehicleId,setVehicleId] = useState("")
    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    const handleShow = (id) => {
      console.log(id);
      setVehicleId(id);
      setIsEdit(true)
      
      setShow(true)}
 console.log("show",StuffsVan);
 
  return (
    <>
          <VanModal getVehicleById={getVehicleById} vehicleById={vehicleById} idVehicle={vehicleId} Edit={isEdit} show={show} handleClose={handleClose} />
    
      <div className="col-md-12">
        <div className=" p-4 card-style">
          <h5 className="fw-bold">Van # {vehicleById.id}</h5>
          <img src={Van} alt="Van Profile" className="card-img-top vanimage " />
          <div className="card-body ">
            <h5 className="card-title d-flex align-items-center justify-content-start">
              <div className="d-flex align-items-center justify-content-between"></div>
              <img src={Logo} alt="Logo" />
              {vehicleById.name}
            
            </h5>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <InfoItem
                  label="Van Capacity (max level)"
                  value={vehicleById?.capacity}
                />

                <div className="progress " style={{ height: "10px" }}>
                  <div
                    className={` ${
                      vehicleById?.capacity > 7 && vehicleById?.capacity <= 10
                        ? "bg-success"
                        : vehicleById?.capacity > 3 && vehicleById?.capacity < 7
                        ? "bg-warning"
                        : vehicleById?.capacity === 0
                        ? "bg-transparent"
                        : vehicleById?.capacity > 0 && vehicleById?.capacity < 3
                        ? "bg-danger"
                        : ""
                    }`}
                    role="progressbar"
                    style={{
                      width:
                        vehicleById?.capacity === 10
                          ? "100%"
                          : vehicleById?.capacity > 7
                          ? "90%"
                          : vehicleById?.capacity > 3 &&
                            vehicleById?.capacity < 7
                          ? "50%"
                          : vehicleById?.capacity > 0 &&
                            vehicleById?.capacity < 3
                          ? "30%"
                          : vehicleById?.capacity === 0
                          ? "0%"
                          : "",
                    }}
                    aria-valuenow={vehicleById?.capacity}
                    aria-valuemin="0"
                    aria-valuemax="10"
                  ></div>
                </div>
                <div>
                  <div className="d-flex align-items-center justify-content-between  my-1">
                    <InfoItem
                      label="Available Services"
                      value=""
                      className=""
                    />
                    <div className="d-flex  ">
                      {vehicleById.service_categories?.length > 0 ? (
                        <>
                          {vehicleById.service_categories.map((service) => (
                            <img
                              className="service-icon"
                              src={
                                "https://estbn.com/MobileAppBackend/public" +
                                service.icon_url
                              }
                              alt="service-icon"
                            />
                          ))}
                        </>
                      ) : (
                        <button
                          className=" border-0 bg-transparent button-size"
                          onClick={() => setActivePage("Services")}
                        >
                          Add Service
                          <img src={AddServiceIcon} alt="add-service" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <InfoItem
                  label=" Supervisor"
                  value={
                    vehicleById?.supervisor?.length > 0 ? (
                      vehicleById?.supervisor[0]?.first_name +
                      " " +
                      vehicleById?.supervisor[0]?.last_name
                    ) : (
                      <button className=" border-0 bg-transparent button-size">
                        Add Supervisor
                        <img src={AddServiceIcon} alt="add-stuff" />
                      </button>
                    )
                  }
                />
                <InfoItem
                  label=" Driver"
                  value={
                    StuffsVan.driverVan ? (
                      StuffsVan.driverVan?.first_name +
                      " " +
                      StuffsVan.driverVan?.last_name
                    ) : (
                      <button
                        onClick={() => setActivePage("StaffVans")}
                        className=" border-0 bg-transparent button-size"
                      >
                        Add Driver
                        <img src={AddServiceIcon} alt="add-stuff" />
                      </button>
                    )
                  }
                />
                <InfoItem
                  label="Engineer"
                  value={
                    StuffsVan.engineerVan ? (
                      StuffsVan.engineerVan?.first_name +
                      " " +
                      StuffsVan.engineerVan?.last_name
                    ) : (
                      <button
                        onClick={() => setActivePage("StaffVans")}
                        className=" border-0 bg-transparent button-size"
                      >
                        Add Engineer
                        <img src={AddServiceIcon} alt="add-stuff" />
                      </button>
                    )
                  }
                />
                <InfoItem
                  label="Technician"
                  value={
                    StuffsVan.technicianVan ? (
                      StuffsVan.technicianVan?.first_name +
                      " " +
                      StuffsVan.technicianVan?.last_name
                    ) : (
                      <button
                        onClick={() => setActivePage("StaffVans")}
                        className=" border-0 bg-transparent button-size"
                      >
                        Add Technician
                        <img src={AddServiceIcon} alt="add-stuff" />
                      </button>
                    )
                  }
                />
              </li>
              <li className="list-group-item fw-600 van-info-list">
              <div className="d-flex align-items-center">  Van Info   <img
              onClick={()=>handleShow(vehicleById.id)}
                src={Editicon}
                className="cursor-pointer ms-auto"
                alt="Edit"
              /></div>
                <InfoItem
                  value={vehicleById.engine_type?.name}
                  label="Fuel Type"
                />
                <InfoItem
                  value={vehicleById.engine_size?.size_cc}
                  label="Engine size"
                />
                <InfoItem value="30.000-40.000" label="Number of Kilometers" />
                <InfoItem
                  value={`W ${vehicleById.tyre_dimension?.width} / H ${vehicleById.tyre_dimension?.height} / D ${vehicleById.tyre_dimension?.width}`}
                  label="Tire size"
                />
                <InfoItem
                  value={vehicleById.battery_capacity?.name}
                  label="Battery Size"
                />
                <InfoItem
                  value={vehicleById.chassis_number}
                  label="Chassis Number"
                />
                <InfoItem
                  value={vehicleById.transmission_type?.name}
                  label="Transmission Type"
                />
                <InfoItem
                  value={vehicleById.vehicle_type?.type}
                  label="Vehicle Type"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
export default VanProfileCard;
